module.exports = __webpack_public_path__ + "static/media/savant.8ae72bc1.svg";